// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const FlagIcon: MarkdocTagRegistration = {
  tag: 'flag-icon',
  component: 'FlagIcon',
  selfClosing: true,
  attributes: {
    country: {
      type: String,
      required: true,
      description: 'The 2-letter ISO Alpha-2 country code',
    },
    title: {
      type: String,
      required: false,
      description:
        'The text to be shown in the tooltip when the user hovers their mouse over the flag',
    },
    label: {
      type: String,
      required: false,
      description:
        'The text to show to the side of the flag icon, typically the country name',
      localizable: true,
    },
    inline: {
      type: Boolean,
      required: false,
      default: true,
      description:
        'Whether to render the flag inline so that it can be used within a paragraph',
    },
  },
};
